import { initialState } from "../all.slice";

const resetOtherData = () => {
    return initialState;
}

export default resetOtherData;